import React, {useEffect, useState} from 'react';
import Footer from "../layout/Footer";
import { useLocalStorage } from "../useLocalStorage";
import "./Point.css";
import Swal from 'sweetalert2';
import toast, { Toaster } from 'react-hot-toast';
import M from "materialize-css";

import banner1 from "../logo.svg"
import { API_URL, CMS_URL, numberWithCommas, THEME_COLOR } from '../constant';
import {CopyToClipboard} from 'react-copy-to-clipboard';

import jwt  from 'jsonwebtoken';
import HeaderBack from '../layout/HeaderBack';
import gift from "../images/icon/giftbox.svg"
import { Button, Stack,TextField, Typography } from '@mui/material';
import TabPanel from '@mui/lab/TabPanel';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import ImageIcon from '@mui/icons-material/Image';
import WorkIcon from '@mui/icons-material/Work';
import BeachAccessIcon from '@mui/icons-material/BeachAccess';

const Point = ()=>{
    const [token, setToken] = useLocalStorage("token", "");
    const [memberCode, setMemberCode] = useState("");
    const [value, setValue] = useState("1");
    const [pointHistory, setPointHistory] = useState([])
    const [gifts, setGifts] = useState([])

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    function getGift(){
        var myHeaders = new Headers();
        myHeaders.append("x-access-token", token);

        var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
        };

        return fetch(`${API_URL}api/point/gift`, requestOptions)
        .then(response => response.json())
        .catch(error => {});
    }

    function getHistory(){
        var myHeaders = new Headers();
        myHeaders.append("x-access-token", token);

        var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
        };

        return fetch(`${API_URL}api/point/history`, requestOptions)
        .then(response => response.json())
        .catch(error => {});
    }

    useEffect(async ()=>{
        let historyresponse = await getHistory();
        if(historyresponse && historyresponse.status == 200){
            setPointHistory(historyresponse.data);
        }else{
            toast.error("Something went wrong!");
        }
        let giftresponse = await getGift();
        if(giftresponse && giftresponse.status == 200){
            setGifts(giftresponse.data);
        }else{
            toast.error("Something went wrong!");
        }
        setMemberCode(jwt.decode(token));
    },[]);

    const HistoryElement = (
        <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
            {
                pointHistory.map((value, index)=>{
                    return(
                        <ListItem>
                            <ListItemText primary={value.Code} secondary={
                                <React.Fragment>
                                    <Typography
                                        sx={{ display: 'inline'}}
                                        component="span"
                                        variant="body2"
                                        color="text.primary"
                                    >
                                        <p></p>
                                        <Typography sx={{fontSize:'10pt', color:'#AAA'}}>Date</Typography>
                                        <Typography>{value.SysDate}</Typography>

                                        {
                                            (value.TransType != "SREDM") ? (
                                                <>
                                                    <p></p>
                                                    <Typography sx={{fontSize:'10pt', color:'#AAA'}}>Sub Total</Typography>
                                                    <Typography>Rp. {numberWithCommas(value.GrandTotal)}</Typography>
                                                </>
                                            ) : null
                                        }
                                        
                                        <p></p>
                                        <Typography sx={{fontSize:'10pt', color:'#AAA'}}>Total Point</Typography>
                                        <Typography>{(value.TransType == "SREDM") ? `-` : ``}{value.TotalPoint}</Typography>
                                        <hr />
                                    </Typography>
                                </React.Fragment>
                            } />
                        </ListItem>
                    )
                })
            }
        </List>
    );

    const GiftElement = (
        <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
            {
                gifts.map((value,index)=>{
                    let imgurl = `${CMS_URL}/images/no-image-found.jpg`;
                    if(value.ImageName){
                        imgurl = `${CMS_URL}/images/upload/product/${value.Code}/${value.ImageName}`;
                    }
                    return(
                        <ListItem>
                            <Card sx={{ width: '100%', display: 'flex',alignItems:'center' }}>
                                <CardMedia
                                    component="img"
                                    sx={{ width: 151 }}
                                    image={imgurl}
                                    alt={value.Name}
                                />
                                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                    <CardContent sx={{ flex: '1 0 auto',alignItems:'center' }}>
                                        <Typography component="div" variant="h6">
                                            {value.Name}
                                        </Typography>
                                        <Typography variant="subtitle1" color="text.secondary" component="div">
                                            Point : {value.RedeemPoint}
                                        </Typography>
                                            <a href={`/pointdetail/${value.Code}`} className={`btn ${THEME_COLOR}`}>Redeem</a>
                                    </CardContent>
                                </Box>
                            </Card>
                        </ListItem>
                    );
                })
            }
        </List>
    );

    return(
        <React.StrictMode>
            <Toaster
                position="bottom-center"
            />
            <HeaderBack title="Point"/>
            <div className='point-body'>
                <div className='point-description'>
                    <p>*Note: Setiap pembelanjaan ke web akan mendapatkan poin yg bisa diakumulasi. Nilai poin yang akan didapatkan bisa dilihat langsung ketika Anda order.</p>

                    <p>Tukar poin Anda dengan hadiah-hadiah di bawah ini, GRATIS tanpa diundi. Mohon untuk diperhatikan syarat dan ketentuan dalam penukaran poin:</p>

                    <ul style={{listStyleType:"disc", border:"0", paddingLeft:"20px"}}>
                        <li className=''>Pajak hadiah ditanggung oleh pemenang.</li>
                        <li className=''>Ketersediaan warna atau tipe produk dapat berubah sewaktu - waktu tergantung stok yang tersedia saat ini.</li>
                        <li className=''>Nilai poin tidak mengikat, dapat berubah jika ada perubahan harga dari Vendor.</li>
                        <li className=''>Ongkos pengirman ditanggung oleh Reseller.</li>
                    </ul>
                </div>
                {/* <Tabs value={value} onChange={handleChange} aria-label="disabled tabs example" centered variant='fullWidth'>
                    <Tab label="Product" />
                    <Tab label="History" />
                </Tabs> */}
                
                <TabContext value={value}>
                    <TabList onChange={handleChange} aria-label="lab API tabs example" centered variant='fullWidth'>
                        <Tab label="Product" value="1" />
                        <Tab label="History" value="2" />
                    </TabList>
                    <TabPanel value="1">{GiftElement}</TabPanel>
                    <TabPanel value="2">{HistoryElement}</TabPanel>
                </TabContext>
            </div>
        </React.StrictMode>
    );
}


export default Point;